/**
|--------------------------------------------------
| @class 产品中心主入口
|--------------------------------------------------
*/
import Vue from 'vue';
import ElementUI from 'element-ui';
import "ant-design-vue/dist/antd.css";
import 'element-ui/lib/theme-chalk/index.css';
import App from './components/products.vue';
import { server } from '../../utils/api';
import { TreeSelect } from 'ant-design-vue'
import router from './router';

Vue.use(ElementUI)
Vue.use(TreeSelect)
Vue.prototype.$server = server;

new Vue({
    el: '#app',
    // router,
    render: h => h(App)
})


// WEBPACK FOOTER //
// ./src/components/products/products.js